/**
 * Chat widget view for the file uploade
 */
import springyView from '../../tools/SpringyView.js';
import FileDrop from '../../tools/FileDrop.js';
import { jqGetAjaxError } from '../../tools/requestUtil.js';
import { focusFirst } from '../../tools/focusUtil.js';

const fileView = Object.create(springyView);

/**
 * @prop {Object} events Default events.
 */
fileView.events = {
    'click .btn-file-cancel': 'closeView',
    keydown: 'trapFocus'
};
/**
 * Wrapper for springyView.init in case we need extra functionality.
 * @param {Object} config Config data.
 * @param {chatWidget} config.model Widget object for this view.
 * @param {Object} config.$el Div for this view. $('#autoload') for now.
 * @param {String} config.template_id Template data for main html.
 */
fileView.initialize = function(config) {
    if (config.patronSession) {
        this.patronSession = config.patronSession;
    }
    if (config.emitter) {
        this.emitter = config.emitter;
    }
    config.$el = window.$('#file');
    this.init(config);
};
/**
 * Close the view (reshow chat pane)
 */
fileView.closeView = function() {
    this.filedrop.reset();

    this.$submitButton.val(this.model.get('file_action')).prop('disabled', false);

    this.emitter.trigger('changeView', 'chat');
};

/**
 * Validate the filedrop widget.
 * @param {Object} filedrop The filedrop object
 * @return {Boolean}
 */
fileView.formValidate = function(filedrop) {
    // this is bound to filedrop widget.
    if (filedrop.countFiles() === 0) {
        filedrop.showError(this.model.get('translation').ch_file_nofiles);
        return false;
    }
    if (this.$form.find('input[name=channel]').length === 0) {
        this.$form
            .prepend( window.$('<input type="hidden" name="channel" />')
                .val(this.patronSession.getChannel())
            );
    } else {
        this.$form.find('input[name=channel]').val(this.patronSession.getChannel());
    }
    return true;
};
/**
 * Error on the upload process.
 * @param {Object} jqXhr jQuery xhr object.
 * @param {Object} filedrop The filedrop widget.
 */
fileView.formError = function(jqXhr, filedrop) {
    let msg = '';
    if (Number(jqXhr.status) === 413) {
        msg = this.model.get('translation').ch_file_toolarge;
    } else if (Number(jqXhr.status) === 400) {
        msg = jqGetAjaxError(jqXhr);
    } else {
        msg = this.model.get('translation').ch_file_error;
    }
    filedrop.showError(msg);
};
/**
 * Form upload success callback.
 * @param {Object} data Data from script.
 * @param {Object} filedrop The filedrop widget.
 */
fileView.formSuccess = function(data, filedrop) {
    const message = document.createElement('span');
    message.innerText = 'attached a file: ';
    const fileLink = document.createElement('a');
    fileLink.href = data.url;
    fileLink.setAttribute('target', '_blank');
    fileLink.classList.add('s-la-cfile');
    fileLink.innerText = data.url;
    if (data.preview === 'inline' || data.preview === 'modal') {
        fileLink.dataset.preview = data.preview;
    }
    message.appendChild(fileLink);
    this.emitter.trigger('fileUpload', message.outerHTML);
    filedrop.reset();
};
/**
 * Show this view and set focus as appopriate
 */
fileView.showView = function() {
    this.$el.removeClass('hidden');
    focusFirst(this.el);
};
/**
 * Render the view
 * @return {autoView}
 */
fileView.render = function() {
    // clear out existing content, events, etc.
    this.$el.empty();

    // render the template and put it in the dom.
    const templateData = this.model.toJSON();
    templateData.channel = this.patronSession.getChannel();
    this.$el.html(this.templateEng.render('pane_fileupload.njk', templateData));
    this.$form = this.$el.find('form');
    this.$submitButton = this.$form.find('button[type=submit]');

    /**
     * File Upload form
     */
    this.filedrop = new FileDrop({
        form: this.$form[0],
        autoupload: false,
        max_files: 1,
        max_upload_size: 20971520,
        max_file_size: 20971520,
        callback: this.formSuccess.bind(this),
        error_callback: this.formError.bind(this),
        validate: this.formValidate.bind(this),
        translations: {
            max_file_size: this.model.get('max_file_size_label')
        }
    });
    this.filedrop.init();

    return this;
};

export default fileView;
